export default function Step2() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="45" viewBox="0 0 44 45" fill="none">
            <path
                d="M22.0001 38.3781C30.5053 38.3781 37.4001 31.4834 37.4001 22.9781C37.4001 14.4729 30.5053 7.57812 22.0001 7.57812C13.4949 7.57812 6.6001 14.4729 6.6001 22.9781C6.6001 31.4834 13.4949 38.3781 22.0001 38.3781Z"
                stroke="white"
                strokeWidth="1.32"
                strokeLinejoin="round"
            />
            <path
                d="M7.1499 25.1784C9.02446 25.9641 10.9886 27.9062 11.8129 27.1205C13.0493 25.9419 11.9824 22.3651 13.7141 21.3786C15.4457 20.3922 18.0839 24.7649 20.5498 23.3261C23.0157 21.8872 20.3175 18.0507 22.0287 16.4953C23.74 14.9399 25.9651 16.6941 26.3541 14.0933C26.743 11.4927 24.6228 10.586 24.1999 8.12842"
                stroke="white"
                strokeWidth="1.32"
                strokeLinecap="round"
            />
            <path
                d="M23.1024 37.8283C22.1321 36.9419 21.7828 36.118 22.0545 35.3565C22.4621 34.2143 25.5473 34.5495 26.4019 33.4283C27.2564 32.307 27.5019 31.2283 29.1519 31.2283C30.8019 31.2283 32.4519 32.3283 33.0023 32.8701"
                stroke="white"
                strokeWidth="1.32"
                strokeLinecap="round"
            />
            <path
                d="M35.2767 15.2783C39.4065 15.6178 42.2405 16.8112 42.8001 18.7783C43.9194 22.713 35.5143 28.2532 24.0267 31.1525C12.5392 34.0518 2.31939 33.2125 1.2001 29.2778C0.613667 27.2162 2.6417 24.714 6.35773 22.3819"
                stroke="white"
                strokeWidth="1.32"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
